import { useMutation } from '@apollo/client/react';
import { PushHubspotMetadataFieldValuesDocument } from './query.gql';
export function usePushHubspotMetadataFieldValues() {
    const [mutate, state] = useMutation(PushHubspotMetadataFieldValuesDocument);
    const pushValues = (fieldMappingId, objectId, values) => mutate({
        variables: {
            input: {
                fieldMappingId,
                objectId,
                values,
            },
        },
    });
    return [pushValues, state];
}
